<template>
  <b-card class="accordion" body-class="accordion-scroll" role="tablist">
    <b-tooltip target="disabled-coming-soon">{{ $t('ia.general.comingSoon') }}</b-tooltip>
    <div :class="`
        mt-1 position-relative 
        ${section_left.class ? section_left.class : ''}
        ${section_left.disabled ? 'disabled' : ''}
      `" v-for="(section_left, index) in sectionsComputed" :key="index">
      <div class="disabled-collapse" v-if="section_left.disabled" id="disabled-coming-soon"></div>
      <div class="d-flex justify-content-between align-items-center position-relative"
        @click="clickCollapse(`icon_plus_${index}`, index)" v-b-toggle="`collapse_box_${index}`">
        <span>
          <img :src="section_left.icon" class="size-icons-left" />{{ section_left._title }}
          <b-badge v-if="section_left.new" variant="primary" class="custom-badge-sections-ia">{{ $t('newFeature')
          }}</b-badge>
        </span>
        <div class="container-plus-less-icon" :ref="`icon_plus_${index}`" v-show="!section_left.disabled">
          <span></span>
          <span></span>
        </div>
      </div>
      <b-collapse :id="`collapse_box_${index}`" accordion="options-accordion" role="tab">
        <b-button-group vertical :key="update_buttons_left">
          <b-button :class="[
            category_selected.section === section_left.section && category_selected.category === subsection.category ? 'button-option-colllapse-active' : 'button-option-colllapse',
            subsection.is_divider ? 'btn-divider' : '',
            subsection.is_base_separator ? 'btn-base-separator' : ''
          ]" variant="button-option-colllapse" class="avenir-medium d-flex align-items-center"
            @click="redirectCategory({ section: section_left.section, category: subsection.category })"
            v-for="(subsection, index_subsection) in section_left._sub_sections" :key="index_subsection"
            :disabled="subsection.disabled">
            {{ subsection._title }}
            <b-badge v-if="subsection.new"
              :variant="category_selected.section === section_left.section && category_selected.category === subsection.category ? 'light' : 'primary'"
              class="custom-badge-sections-ia"
              :class="{ 'text-dark': category_selected.section === section_left.section && category_selected.category === subsection.category }">{{
                $t('newFeature') }}</b-badge>
          </b-button>
        </b-button-group>
      </b-collapse>
    </div>
    <template #footer>
      <div class="footer-sider-left" @click="$emit('show_modal_update_suscription')" v-if="all_plans.length > 0">
        <feather-icon icon="CodesandboxIcon" class="icon-footer-sider"></feather-icon>
        <div>
          <span class="d-block avenir-medium">{{ credits >= 0 ? separatebycomma(credits) : '0' }} {{
            $t('ia.sidebarLeft.remainingCredits') }}</span>
          <span v-if="plan_order !== all_plans.length - 1 && credits <= 200">{{ $t('ia.sidebarLeft.updateTo') }} {{
            all_plans[plan_order + 1].name }}</span>
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
import {
  VBToggle,
  BCollapse,
  BButton,
  BButtonGroup,
  BCard,
  BTooltip,
  BBadge,
} from "bootstrap-vue";
import { separatebycomma } from '@/libs/utils/formats';
import { getUserData } from "@/libs/utils/user";

export default {
  name: 'siderLeftSections',

  components: {
    BCollapse,
    BButton,
    BButtonGroup,
    BCard,
    BTooltip,
    BBadge
  },
  directives: {
    'b-toggle': VBToggle
  },
  props: {
    category_selected: {
      type: Object
    },
    credits: {
      type: Number,
      default: 0
    },
    all_plans: {
      type: Array,
      default: () => {
        return [];
      }
    },
    favorites_assistants: {
      type: Array,
      default: () => []
    },
    recent_assistants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      separatebycomma,
      update_buttons_left: false,
      sections: [
        {
          titleKey: 'search.community',
          icon: require('@/assets/images/icons/grid.svg'),
          section: 'community',
          sub_sections: [{ titleKey: 'search.showcase' }]
        },
        {
          titleKey: 'search.images',
          icon: require('@/assets/images/icons/imageIcon.svg'),
          section: 'image',
          sub_sections: [
            { titleKey: 'search.textImage', category: 'txt-to-image' },
            { titleKey: 'ia.reimagine.reimagine', category: 'reimagine', new: true }
          ]
        },
        {
          title: 'Chat',
          icon: require('@/assets/images/icons/chat.svg'),
          section: 'chat',
          sub_sections: [{ titleKey: 'search.chat_gpt', category: 'chat-gpt' }]
        },
        {
          titleKey: 'search.video',
          icon: require('@/assets/images/icons/cameraVideo.svg'),
          section: 'video',
          sub_sections: [{ titleKey: 'ia.sidebarLeft.talkingPortraits', category: 'talking-portrait' }],
        },
        {
          titleKey: 'search.text',
          icon: require('@/assets/images/icons/text.svg'),
          section: 'text',
          sub_sections: [
            { titleKey: 'ia.assistants.catalog.social-post.name', category: 'social-post' },
            { titleKey: 'ia.assistants.catalog.rewrite.name', category: 'rewrite' },
            { titleKey: 'ia.assistants.catalog.product-review.name', category: 'product-review' },
            { titleKey: 'ia.assistants.catalog.brand-pitch.name', category: 'brand-pitch' },
            { titleKey: 'ia.assistants.catalog.email-campaign.name', category: 'email-campaign' },
            { titleKey: 'ia.assistants.catalog.video-script.name', category: 'video-script' },
          ],
        },
        {
          titleKey: 'ia.assistants.assistants',
          icon: require('@/assets/images/icons/ai-section.png'),
          section: 'assistants',
          new: true,
          sub_sections: [
            { title: 'Explore Assistants', category: 'assistants' },
            { title: 'Explore Personas', category: 'personas' },
          ],
        },
        {
          class: 'border-top pt-1',
          titleKey: 'search.history',
          icon: require('@/assets/images/icons/historyClock.svg'),
          section: 'histories',
          sub_sections: [
            { titleKey: 'lists.image', category: 'image' },
            { title: 'Video', category: 'video' },
            { titleKey: 'search.text', category: 'text' }
          ]
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.has_banned) {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'auto' })
      }
    });
  },
  watch: {
    favorites_assistants: { handler() { this.rebuildAssistantsSection(); }, deep: true, immediate: true },
    recent_assistants: { handler() { this.rebuildAssistantsSection(); }, deep: true, immediate: true }
  },
  computed: {
    plan_order() {
      if (getUserData()) return getUserData().current_plan.order
      else return 0
    },
    has_banned() {
      return getUserData().meta_info
    },
    sectionsComputed() {
      return this.sections.map(section => {
        const _title = section.titleKey ? this.$t(section.titleKey) : (section.title || '');
        const _sub_sections = (section.sub_sections || []).map(sub => {
          return {
            ...sub,
            _title: sub.titleKey ? this.$t(sub.titleKey) : (sub.title || ''),
          };
        });
        return { ...section, _title, _sub_sections };
      });
    }
  },
  methods: {
    rebuildAssistantsSection() {
      const assistantsSection = this.sections.find(s => s.section === 'assistants');
      if (!assistantsSection) return;
      const base = [
        { title: 'Explore Assistants', category: 'assistants' },
        { title: 'Explore Personas', category: 'personas' },
      ];
      const favorites = (this.favorites_assistants || []).map(f => ({ ...f, favorite: true, titleKey: `ia.assistants.catalog.${f.category}.name` }));
      const recents = (this.recent_assistants || []).map(r => ({ ...r, recent: true, titleKey: `ia.assistants.catalog.${r.category}.name` }));
      const blocks = [];
      if (favorites.length) {
        blocks.push({ titleKey: 'twitter.favorites', disabled: true, is_divider: true });
        blocks.push(...favorites);
      }
      if (recents.length) {
        blocks.push({ titleKey: 'ia.assistants.recentlyUsed', disabled: true, is_divider: true });
        blocks.push(...recents);
      }
      blocks.push({ title: '', disabled: true, is_divider: true, is_base_separator: true });
      assistantsSection.sub_sections = [...blocks, ...base];
      this.update_buttons_left = !this.update_buttons_left;
    },
    openModal() {
      if (this.plan_order !== this.all_plans.length - 1 && this.credits <= 200) {
        this.open_modal_plans_group = true;
        this.update_modal = !this.update_modal;
      }
    },
    clickCollapse(icon_plus, index) {
      this.clearActive(index)
      const container_icon = this.$refs[icon_plus][0];
      container_icon.classList.toggle("transition-icon-plus");
    },
    clearActive(index) {
      for (let i = 0; i < this.sections.length; i++) {
        if (i !== index) this.$refs[`icon_plus_${i}`][0].classList.remove('transition-icon-plus')
      }
    },
    redirectCategory(selected) {
      if (selected.disabled || selected.is_divider) return;
      this.category_selected.section = selected.section || 'assistants';
      this.category_selected.category = selected.category;
      this.update_buttons_left = !this.update_buttons_left;
      this.$router.push({ name: 'brandme_AI', params: { section: this.category_selected.section, category: selected.category } }).catch(() => { })
      this.$emit('update-section', selected);
      if (this.has_banned) {
        this.$nextTick(() => {
          window.scrollTo({ top: document.body.scrollHeight, behavior: 'auto' })
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.accordion-scroll {
  overflow-y: auto;
}
.accordion {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;

  .disabled-collapse {
    cursor: default;
    background-color: rgba(255, 255, 255, 0.521);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    height: 100%;
  }

  .footer-sider-left {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    padding: 1em;
    margin: 0 1em;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 1em;
    cursor: pointer;

    .icon-footer-sider {
      width: 25px;
      height: 25px;
      margin-right: 1em;
    }

    &:hover {
      background: linear-gradient(118deg, #7267f0d0, rgba(114, 103, 240, 0.747));
    }
  }

  .size-icons-left {
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.5rem;
  }

  .container-plus-less-icon {
    background: transparent;
    width: 30px;
    height: 30px;
    border: 0;
    position: relative;

    span {
      position: absolute;
      transition: 300ms;
      background: #999999;

      &:first-child {
        top: 25%;
        bottom: 25%;
        width: 10%;
        left: 45%;
      }

      &:last-child {
        left: 25%;
        right: 25%;
        height: 10%;
        top: 45%;
      }
    }
  }

  .transition-icon-plus span {
    transform: rotate(90deg);
  }

  .transition-icon-plus span:last-child {
    left: 50%;
    right: 50%;
  }

  .button-option-colllapse-active {
    margin-left: 2.1rem;
    display: flex;
    text-align: start;
    color: #fff;
    background-color: #6c757d;
    border-radius: 0.5rem !important;
  }

  .button-option-colllapse {
    margin-left: 2.1rem;
    display: flex;
    text-align: start;
    background-color: #fff;
    border-radius: 0.5rem !important;

    &:hover {
      color: #212529;
      background-color: #e9ecef;
    }

    &:disabled {
      background-color: #fff;
    }
  }

  .btn-divider,
  .btn-base-separator {
    cursor: default !important;
    pointer-events: none;
    background: transparent !important;
    color: #888 !important;
    font-weight: 600;
    margin-top: 0.75rem;
  }

  .btn-base-separator {
    border-top: 1px solid #e2e2e2;
  }
}
</style>
<style lang="scss">
.accordion {
  .card-footer {
    padding: 1em 0;
  }
}

.custom-badge-sections-ia {
  border-radius: 3em;
  margin-left: 0.5em;
}
</style>